import React from 'react';
import classnames from 'classnames';

import styles from './index.module.scss';

/** @type {React.FC<{className?: string; children?: React.ReactNode}>} */
export const ButtonsGroup = ({ className, children }) => (
    <div className={classnames(className, styles.buttonsGroup, 'flex flex-center')}>{children}</div>
);
